module.exports = __webpack_public_path__ + "img/icon_copy.6f111dd2.svg";